import template from './sidemenu-button.html';

let sidemenuButtonComponent = {
//    restrict: 'E',
    bindings: {
        label: '@',
        state: '@'
    },
    replace: true,
    transclude: true,
    template: template,
    controller: function() {}
};

export default sidemenuButtonComponent;
